import { Box, Drawer, Group, Paper, Text, ThemeIcon } from "@mantine/core";
import { IconMail, IconPhone, IconWorld } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";

interface Props {
  opened: boolean;
  close: () => void;
}
type ConfigItem = {
  parCode: string;
  parName: string;
  parValue: string;
  parValueEN?: string;
  parValueEn?: string;
};
const getConfigValue = (
  list: ConfigItem[],
  parCode: string,
  parName: string,
  lang: "VI" | "EN" = "VI",
) => {
  const item = list.find(
    (it) => it.parCode === parCode && it.parName === parName,
  );

  if (!item) return "";

  // Ưu tiên theo ngôn ngữ
  if (lang === "EN") {
    return item.parValueEN || item.parValueEn || item.parValue || "";
  }

  return item.parValue || "";
};

const ContactItem = ({
  icon,
  label,
  value,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
}) => {
  return (
    <Paper
      radius="xl"
      p="12px"
      withBorder={false}
      sx={{
        backgroundColor: "#fff",
        borderRadius: 20,
      }}
    >
      <Group spacing="md">
        <ThemeIcon radius="xl" size={40} sx={{ backgroundColor: "#E5F1FF" }}>
          {icon}
        </ThemeIcon>

        <Group spacing={6}>
          <Text fw={700} fz="md">
            {label}
          </Text>
          <Text fw={500} fz="md" c="#2A81D0">
            {value}
          </Text>
        </Group>
      </Group>
    </Paper>
  );
};

const DrawerContract = ({ opened, close }: Props) => {
  const [configData, setConfigData] = useState<any>(null);

  const bizContact: ConfigItem[] = useMemo(() => {
    if (!configData) return [];
    return configData.filter((item: any) => item.parCode === "BIZ_CONTACT");
  }, [configData]);
  const lang = (localStorage.getItem("language") ?? "VI").toUpperCase() as
    | "VI"
    | "EN";

  const hotline = getConfigValue(bizContact, "BIZ_CONTACT", "HOTLINE", lang);
  const { t } = useTranslation();
  const email = getConfigValue(bizContact, "BIZ_CONTACT", "EMAIL", lang);
  return (
    <Drawer opened={opened} onClose={close} title={`${t("CONTACT")}`} position="right">
      {/* Drawer content */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Box style={{ border: "1px solid #D8DDE2", borderRadius: 20 }}>
          <ContactItem
            icon={<IconWorld size={20} color="#2A81D0" />}
            label="Website:"
            value="https://protontech.vn/"
          />
        </Box>

        <Box style={{ border: "1px solid #D8DDE2", borderRadius: 20 }}>
          <ContactItem
            icon={<IconPhone size={20} color="#2A81D0" />}
            label="Hotline:"
            value={hotline || "1900 0918 71"}
          />
        </Box>

        <Box style={{ border: "1px solid #D8DDE2", borderRadius: 20 }}>
          <ContactItem
            icon={<IconMail size={20} color="#2A81D0" />}
            label={`${t("SUPPORT_EMAIL_LABEL")}`}
            value={email || "lienhe@protontech.vn"}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerContract;
